import { create } from "zustand";
import { SeedModule } from "../types/api";

interface PermissionSeedState {
  seed: SeedModule[];
  setSeed: (seed: SeedModule[]) => void;
  clearSeed: () => void;
}

export const usePermissionSeedStore = create<PermissionSeedState>((set) => ({
  seed: [],
  setSeed: (seed) => set({ seed }),
  clearSeed: () => set({ seed: [] }),
}));
